import { Dialog as BaseDialog } from '@base-ui/react/dialog'

// Base UI primitives
const { Root, Portal, Description, Close, Trigger, Viewport } = BaseDialog
export { Close, Description, Portal, Root, Trigger, Viewport }

// Custom styled components
export { Backdrop } from './backdrop'
export { CloseButton } from './close-button'
export { Content } from './content'
export { Footer } from './footer'
export { Header } from './header'
export { Popup } from './popup'
export { Title } from './title'
